__turbopack_context__.v({
  "visualFlatsInfo": "VisualFlatsInfo-module-scss-module__sqCq7W__visualFlatsInfo",
  "visualFlatsInfo__rooms": "VisualFlatsInfo-module-scss-module__sqCq7W__visualFlatsInfo__rooms",
  "visualFlatsInfo__rooms__item": "VisualFlatsInfo-module-scss-module__sqCq7W__visualFlatsInfo__rooms__item",
});
